// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyB0VB_AbI0egIR7HsfpxDVOEPQeL4RysqE",
  authDomain: "myshopcity.firebaseapp.com",
  projectId: "myshopcity",
  storageBucket: "myshopcity.firebasestorage.app",
  messagingSenderId: "18066199474",
  appId: "1:18066199474:web:8a6c32ab275e44a1194aab",
  measurementId: "G-EXCPS09L81"
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
